// pp-liga-estudio.js — entrar al Print Studio YA LIGADO a la cuenta.
//
// POR QUÉ (Padrino, 3-oct-2026): el estudio no tiene login de clientes; cada
// visita es una sesión anónima de ese navegador, así que los diseños solo se
// veían donde se hicieron. Antes de mandar al cliente al estudio, el portal
// pide al edge (App Proxy, cliente firmado) una URL con un token que caduca en
// 10 minutos: GET /apps/crm/customer-liga-estudio → { url }. El estudio la usa
// para ligar su sesión a esta cuenta, y desde entonces «Mis Diseños» los ve.
//
// Uso: cualquier <a data-pp-liga-estudio href="https://print.parapaquetes.com/estudio/editor">
// (opcional data-pp-liga-producto="<shopify product id>"). Si el token no llega,
// se navega al href de siempre: el cliente diseña igual, solo que sin ligar.
(function () {
  'use strict';
  var ENDPOINT = '/apps/crm/customer-liga-estudio';

  function abrir(enlace) {
    var respaldo = enlace.getAttribute('href');
    var producto = enlace.getAttribute('data-pp-liga-producto');
    var url = ENDPOINT + (producto ? '?shopifyProductId=' + encodeURIComponent(producto) : '');
    enlace.setAttribute('aria-busy', 'true');
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var destino = d && typeof d.url === 'string' && d.url.indexOf('https://print.parapaquetes.com/') === 0 ? d.url : respaldo;
        window.location.href = destino;
      })
      .catch(function () { window.location.href = respaldo; });
  }

  document.addEventListener('click', function (e) {
    var enlace = e.target.closest && e.target.closest('a[data-pp-liga-estudio]');
    if (!enlace) return;
    // Ctrl/Cmd-clic o clic medio: el cliente quiere otra pestaña; se respeta y
    // va sin ligar antes que robarle el gesto.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    abrir(enlace);
  });

  window.PPLigaEstudio = { abrir: abrir };
})();
